import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/src/interfaces';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { _downloadFile } from 'app/utils/trip2-query-builder/utils/helpers';
import { ProvidersBillingService } from 'app/pages/providers-billing/providers-billing-service.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-claim-button',
  templateUrl: './batch-claim-button.component.html',
  styleUrls: ['./batch-claim-button.component.scss']
})
export class BatchClaimButtonComponent implements ICellRendererAngularComp {

  public params: any;

  constructor(
    private loading: T2LoadingService,
    private service: ProvidersBillingService,
    private toastrAlertHelper: ToastrAlertHelper,
  ) { }

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.loading.show();

      const batchid = this.params.data.providerclaimid;
      this.service.getBatchClaimReport(batchid)
      .finally(() => {
        this.loading.hiden();
      })
      .subscribe(
        (success) => {
          if (success.status === 200) {
             const name = 'batch-claim-'+ this.params.data.batchid +'.pdf';
            _downloadFile(success.blob(), name);
          } else {
            this.toastrAlertHelper.error(success.statusText);
          }
        },
        (error) => {
          this.toastrAlertHelper.error(error.statusText);
        }
      );
  }

  refresh(): boolean {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/batch-claim-button/batch-claim-button.component.ts